import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import Collapse from '@mui/material/Collapse';
import TableContainer from '@mui/material/TableContainer';
import {
  UilPlus,
  UilCog,
  UilAngleDown,
  UilAngleUp
} from "@iconscout/react-unicons";
import { formatDate, isNull } from "../../utils/Utils";
import Color from "../../enum/Color";
import CreateButton from "../Common/CreateButton";
import SubscriptionModal from "../Modal/SubscriptionModal";
import SubscriptionStatusEnum from "../../enum/SubscriptionStatusEnum";
import SubscriptionInvoices from "../Subscriptions/SubscriptionInvoices";
import EmailTrackingItems from "./EmailTrackingItems";
import EmailTrackingModal from "./EmailTrackingModal";

const EmailTrackingTable = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const customers = props.customers;

  const closeModalHandler = () => {
    setShowModal((prev) => {
      return !prev;
    });

    props.refreshHandler();
  };

  const newModal = () => {
    setShowModal((prev) => {
      return !prev;
    });
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          onClick={() => setOpen(!open)}
          hover={true}
        >
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <UilAngleUp /> : <UilAngleDown />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.companyDisplayName}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <EmailTrackingItems customer={row}/>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <div className="Table">
      <EmailTrackingModal
        isVisible={showModal}
        isReadOnly={isReadOnly}
        closeModalHandler={closeModalHandler}
        customers={customers}
      />
      <CreateButton action={newModal} icon={<UilPlus />} text="New Tracking Url" />

      <Box sx={{ width: "100%" }}>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell align="left" style={{ width: '50px' }} />
                <TableCell align="left">Customer</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isNull(customers) ? (
                <Typography sx={{ m: 1, textAlign: "center" }}>
                  There are no customers at this time. Add a new one.
                </Typography>
              ) :
                customers.map((customer) => {
                  return (
                    <Row key={customer.id} row={customer} />
                  );
                })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
};

export default EmailTrackingTable;
